import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { ApiService, HttpParamsOptions } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FormBuilder } from '@angular/forms';
import { Config } from 'datatables.net';
import Swal from 'sweetalert2';

class DataTablesResponse {
	data!: any[];
	draw!: number;
	recordsFiltered!: number;
	recordsTotal!: number;
}

@Component({
	selector: 'app-scale-list',
	templateUrl: './scale-list.component.html',
	styleUrl: './scale-list.component.css'
})
export class ScaleListComponent implements OnInit, OnDestroy, AfterViewInit {
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/scale-list",
			name: "Scales"
		}
	];

	@ViewChild(DataTableDirective, { static: false }) datatableElement!: DataTableDirective;
	baseURL = environment.API_URL;
	dtOptions: Config = {};
	dataList: any = [];
	allFlagStates: any[] = [];
	flagState: any = null;
	moduleAccess: any = "Full";
	showDeleteLoader: any = null;

	constructor(private formBuilder: FormBuilder, private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService, private http: HttpClient) { }

	ngOnInit(): void {
		this.initDatatable();
	}

	ngOnDestroy(): void {

	}

	ngAfterViewInit(): void {

	}

	initDatatable() {
		this.dtOptions = {
			pagingType: 'full_numbers',
			serverSide: true,
			processing: true,
			ordering: false,
			language: {
				searchPlaceholder: "Search",
				search: ""
			},
			ajax: (dataTablesParameters: any, callback) => {
				let data: any = {
					draw: dataTablesParameters.draw,
					start: dataTablesParameters.start,
					length: dataTablesParameters.length
				}
				if (dataTablesParameters.search.value != "") {
					data.search = dataTablesParameters.search.value;
				}
				const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
				this.http.get<DataTablesResponse>(this.baseURL + "listscales", { params: new HttpParams(httpParams) }).subscribe({
					next: (response: any) => {
						this.dataList = response.data;
						callback({
							recordsTotal: response.recordsTotal,
							recordsFiltered: response.recordsFiltered,
							data: []
						});
					}, error: (error: any) => {
						if (error.status == 401) { return }
						this.toastr.error("Something went wrong.", 'Error!!!', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		}
	}

	refreshTable() {
		this.datatableElement.dtInstance.then((dtInstance) => {
			dtInstance.draw();
		});
	}

	deleteConfirm(uId: any, index: number) {
		Swal.fire({
			title: 'Warning !!!',
			html: 'Are you sure you want to delete Scale <p style="text-align:center;font-size: 15px;"><strong>' + this.dataList[index].scale_name + '</strong>?</p>',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Delete',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#dc3545'
		}).then((result) => {
			if (result.value) {
				this.showDeleteLoader = index;
				this.apiService.deleteScale(uId).subscribe({
					next: data => {
						this.showDeleteLoader = null;
						Swal.fire('Success', 'Scale deleted successfully.', 'success');
						this.refreshTable();
					}, error: (error) => {
						this.showDeleteLoader = null;
						if (error.status == 401) { return }
						if (error.status == 404) {
							Swal.fire('Error', error.error, 'error');
						} else {
							Swal.fire('Error', 'Something went wrong.', 'error');
						}
					}
				});
			}
		})
	}
}